import React, { useState, useEffect } from "react";
import notfound from '../../../Assets/images/il-empty.svg';
import { usePagination, useSortBy, useTable } from "react-table";
import PaginationComponent from "../../../Components/PaginationTableServer/PaginationTableServer";
import { Form, Formik } from "formik";
import SelectCheckField from "../../../Components/SelectCheckField/SelectCheckField";
import RangeDatePicker from "../../../Components/RangeDatePicker/RangeDatePicker";
import Button from "../../../Components/Button/Button";
import Exports from "../../../Components/Exports/Exports";
import useLogin from "../../Autenticacion/Hooks/useLogin";
import moment from "moment";
import validations from "../../../Utils/Validations/Validations";
import { useInformesConservacion } from "../Hooks/useInformesConservacion";

const ConservacionTable = ({ columns, data, fetchData, pageCount: controlledPageCount, currentpage, pageSize: controlledPageSize, sortBy: controlledSortBy, setPagination,}) => {
  const { getTableProps, getTableBodyProps, headerGroups, prepareRow, page, pageCount, gotoPage, state: { pageIndex, pageSize, sortBy }} = useTable
      ({ columns
          , data
          , initialState: { pageIndex: currentpage, pageSize: controlledPageSize, sortBy: controlledSortBy }
          , manualPagination: true
          , pageCount: controlledPageCount
          , autoResetPage: false
          , autoResetSortBy: false
          , manualSortBy: true
        },useSortBy, usePagination
      );
  const [listadoIndicadoresId, setListadoIndicadoresId] = useState([]);
  const [listadoExigenciasId, setListadoExigenciaId] = useState([]);
  const [primeraCarga, setPrimeraCarga] = useState(true);
  const [primeraBusqueda, setPrimeraBusqueda] = useState(false);
  const [cambiarPagina, setCambiarPagina] = useState(false);
  const { usuario } = useLogin();
  const { postObtenerEstadoAutorizacion, listaEstadoAutorizacion, postObtenerIndicadores, indicadorTotal } = useInformesConservacion();

  const descargar = () => {
    fetchData({ formulario: valoresFormularioEnvio, pageIndex, sortBy, exportacion: true });
  };
 
  const [initialValues, setInitialValues] = useState({
    indicadores: [],
    exigencias: [],
    periodo2: [moment().subtract(1, 'M').toDate(), new Date()],
    estado: []
  });

  const [valoresFormularioEnvio, setValoresFormularioEnvio] = useState({
    paginacion: {
      numeroPagina: pageIndex,
      cantidadRegistros: pageSize,
      orderByAscending: false,
      ordenadoPor: "idEvento"
    },
    datosBuscar: {
      usuarioId: usuario.id,
      indicadorId: listadoIndicadoresId,
      exigenciaId: listadoExigenciasId,
      fechaDesde: moment().subtract(1, 'M').format(),
      fechaHasta: moment().format(),
      estadoAutorizacion: listaEstadoAutorizacion,
      exportacion: false,
    }
  });

  const handleIndicadorChange = (selectedIds) => {

    const exigenciasFiltradas = indicadorTotal
      .filter((indicador) => selectedIds.includes(indicador.indicadorId))
      .flatMap((indicador) =>
        indicador.exigencias.map((exigencia) => ({
          value: exigencia.id,
          label: `${indicador.sigla} - ${exigencia.sigla} - ${exigencia.descripcion}`,
        }))
      );
    setListadoExigenciaId(exigenciasFiltradas);
  };

  function BuscarObjetarEvento(values) {
    const fechaInicio = moment(values.periodo2[0]).format();
    const fechaFin = moment(values.periodo2[1]).format();
    const valor = {
      paginacion: {
        numeroPagina: pageIndex,
        cantidadRegistros: pageSize,
        orderByAscending: sortBy.length > 0 ? !sortBy[0].desc : valoresFormularioEnvio.paginacion.orderByAscending,
        ordenadoPor: sortBy.length > 0 ? sortBy[0].id : valoresFormularioEnvio.paginacion.ordenadoPor
      },
      datosBuscar: {
        fechaDesde: fechaInicio,
        fechaHasta: fechaFin,
        exportacion: false,
        estadoAutorizacion: values.estado === "" ? [] : values.estado,
        usuarioId: usuario.id,
        indicadorId: values.indicadores === "" ? [] : values.indicadores,
        exigenciaId: values.exigencias === "" ? [] : values.exigencias
      }
    };
    setValoresFormularioEnvio(valor);
    fetchData({ formulario: valor, pageIndex, sortBy });
  }

  useEffect(() => {
    if(primeraCarga)
    {
      if (listadoIndicadoresId.length > 0 && listaEstadoAutorizacion.length > 0) {
        setInitialValues({
          indicadores: listadoIndicadoresId.map((x) => x.value),
          exigencias: listadoExigenciasId.map((x) => x.value),
          periodo2: [moment().subtract(1, 'M').toDate(), new Date()],
          estado: listaEstadoAutorizacion.map((x) => Number(x.value))
        });
        setPrimeraCarga(false)
      }
    }
  }, [listadoIndicadoresId, listadoExigenciasId, listaEstadoAutorizacion]);

  useEffect(() => {
    const indicadores = indicadorTotal.map((x) => ({
      value: x.indicadorId,
      label: `${x.sigla}`,
    }));
    setListadoIndicadoresId(indicadores);

    const exigencias = indicadorTotal.flatMap((indicador) =>
      indicador.exigencias.map((exigencia) => ({
        value: exigencia.id,
        label: `${indicador.sigla} - ${exigencia.sigla} - ${exigencia.descripcion}`,
      }))
    );
    setListadoExigenciaId(exigencias);
  }, [indicadorTotal]);

  useEffect(() => {
    if (initialValues.indicadores.length > 0 && initialValues.exigencias.length > 0 && initialValues.estado.length > 0) {
      setValoresFormularioEnvio(prev => ({
        ...prev,
        datosBuscar: {
          ...prev.datosBuscar,
          indicadorId: initialValues.indicadores,
          exigenciaId: initialValues.exigencias,
          estadoAutorizacion: initialValues.estado,
        }
      }));
      setPrimeraBusqueda(true)
    }
  }, [initialValues]);

  useEffect(() => {
    if (primeraBusqueda) {
      fetchData({ formulario: valoresFormularioEnvio, pageIndex, sortBy });
      setPagination(values => ({
        ...values,
        sortBy: sortBy
      }));
      setPrimeraBusqueda(false)
      setCambiarPagina(true)
    }
  }, [primeraBusqueda]);

  useEffect(() => {
    if (cambiarPagina) {
      fetchData({ formulario: valoresFormularioEnvio, pageIndex, sortBy });
      setPagination(values => ({
        ...values,
        sortBy: sortBy
      }));
    }
  }, [pageIndex, sortBy]);

  useEffect(() => {
    postObtenerEstadoAutorizacion(usuario.id);
    postObtenerIndicadores(usuario.id);
  }, [])
  
  return (
  <>
    <div className="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center mb-5 gap-3">
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validate={validations}
        onSubmit={(values) => {
          BuscarObjetarEvento(values);
        }}
      >
        {({ values, setFieldValue, setFieldTouched, }) => (
          <Form className="form mb-0">
            <div className="tools order-1 order-lg-0 align-items-start">
              <SelectCheckField
                name="indicadores"
                label='Indicadores'
                options={listadoIndicadoresId}
                onChange={(e, value) => { handleIndicadorChange(value); setFieldValue("indicadores", value) }}
                onBlur={setFieldTouched}
                isMulti={true}
              />
              <SelectCheckField
                name="exigencias"
                label='Exigencias'
                options={listadoExigenciasId}
                onChange={setFieldValue}
                onBlur={setFieldTouched}
                isMulti={true}
              />
              <RangeDatePicker
                startMaxDate={new Date()}
                startMinDate={null}
                endMaxDate={new Date()}
                endMinDate={null}
                name="periodo2"
                onChange={setFieldValue}
                onBlur={setFieldTouched}
              />
              <SelectCheckField
                name="estado"
                label='Estado Autorización IF'
                options={listaEstadoAutorizacion}
                onChange={setFieldValue}
                onBlur={setFieldTouched}
                isMulti={true}
              />
              <Button type="submit" design="btn-primary">Buscar</Button>
            </div>
          </Form>
        )}
      </Formik>
      <div className="exports order-0 order-lg-1">
        <Exports descargar={() => descargar()}
        />
      </div>
    </div>
    <div className="table-responsive brd-top">
      <table className="table" {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => {
            const { key: hgKey, ...hgProps } = headerGroup.getHeaderGroupProps();
            return (
            <tr key={hgKey} {...hgProps}>
              {headerGroup.headers.map((column) => {
                if (data.length > 0) {
                  const { key: thKey, ...thProps } = column.getHeaderProps(column.getSortByToggleProps(), { className: column.className });
                  return (
                  <th key={thKey} {...thProps}>
                    <span className="d-flex align-items-center gap-1">
                      {column.render('Header')}
                      <>
                        {column.isSorted ?
                          (column.isSortedDesc && data.length > 0 ?
                            <i className="ico-chevron-down"></i>
                            :
                            <i className="ico-chevron-up"></i>
                          ) :
                          <>
                            <i className="ico-sort fs-7"></i>
                          </>
                        }
                      </>
                    </span>
                  </th>
                  );
                } else {
                  const { key: thKey, ...thProps } = column.getHeaderProps();
                  return (
                  <th key={thKey} {...thProps}
                  >
                    <span className="d-flex align-items-center gap-1">
                      {column.render('Header')}
                    </span>
                  </th>
                  );
                }
              })}
            </tr>
            );
          })}
        </thead>
        <tbody {...getTableBodyProps()}>
          {
            page.length > 0 && page.map((row) => {
              prepareRow(row)
              const { key: trKey, ...trProps } = row.getRowProps();
              return (
                <tr key={trKey} {...trProps}>
                  {row.cells.map((cell) => {
                    const { key: tdKey, ...tdProps } = cell.getCellProps({
                      className: cell.column.className
                    });
                    return <td key={tdKey} {...tdProps}>
                      {cell.render('Cell')}
                    </td>
                  })}
                </tr>
              )
            }) || <tr><td colSpan={headerGroups[0].headers.length + 1}>
              <div className="d-flex justify-content-center align-items-center flex-column gap-2 py-5">
                <img className="mb-3" src={notfound} alt="" />
                <p className='mb-0 text-primary'>No se encuentran resultados de tu búsqueda.</p>
              </div>
            </td></tr>
          }
        </tbody>
      </table>
      {
        data.length > 0 &&
        <PaginationComponent
          pagesCountServer={pageCount}
          currentPage={pageIndex}
          setCurrentPage={gotoPage}
          alwaysShown={false}
          setPagination={setPagination}
        />
      }
    </div>

  </>

  );
};

export default ConservacionTable;
